var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Int8Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.typed-array.int8-array.js
// module id = 627
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33